import React, { useState } from 'react';
import classNames from 'classnames';
import Loader from 'src/components/Loader';
import styles from './assets/student-create-screen.module.scss';
import AdminLayout from 'src/components/layout/RoleLayout';
import Form from '../../components/StudentForm';
import user from 'src/services/user-auth';
import Breadcrumbs from '../../../../../../components/Breadcrumbs';
import { routes } from '../../../../../../navigation';

export interface StateProps {
    inProgress: boolean;
}

export interface DispatchProps {}

export interface OwnProps {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const StudentCreateScreen: React.FunctionComponent<Props> = (props) => {
    const [files, setFiles] = useState([]);
    const [orderDoc, setOrderDoc] = useState(null);
    const [consentDoc, setConsentDoc] = useState(null);
    const [parentConsentDoc, setParentConsentDoc] = useState(null);
    const handleSub = (handleSubmit: (e: any) => void, e: any) => {
        handleSubmit(e);
    };
    const arrStatValues: { label: string; value: number | string }[] = [];
    const studentStatuses: any = user.getStudentAvailableStatus();

    Object.keys(studentStatuses).forEach((it: any) => {
        arrStatValues.push({ label: it, value: studentStatuses[it] });
    });

    return (
        <AdminLayout>
            <Breadcrumbs
                items={[
                    { name: 'STUDENTS', path: routes.STUDENTS_LIST },
                    { name: `ADD NEW`, path: '' },
                ]}
            />
            <div className={classNames(styles.wrapForm)}>
                {props.inProgress ? <Loader /> : null}
                <Form
                    statuses={arrStatValues}
                    orderDoc={orderDoc}
                    setOrderDoc={setOrderDoc}
                    removeOrderDoc={(id) => {
                        setOrderDoc(null);
                    }}
                    handleSub={handleSub}
                    consentDoc={consentDoc}
                    setConsentDoc={setConsentDoc}
                    removeConsentDoc={(id) => {
                        setConsentDoc(null);
                    }}
                    parentConsentDoc={parentConsentDoc}
                    setParentConsentDoc={setParentConsentDoc}
                    removeParentConsentDoc={(id) => {
                        setParentConsentDoc(null);
                    }}
                    files={files}
                    setFiles={setFiles}
                    removeFile={(id) => {
                        files.splice(id, 1);
                        setFiles([...files]);
                    }}
                    initialValues={{ status: arrStatValues[0] }}
                />
            </div>
        </AdminLayout>
    );
};

export default StudentCreateScreen;
